import SingleBed from "./SingleBed";

export default SingleBed;